import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "Icon / Info" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "icon",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M32 52C43.0457 52 52 43.0457 52 32C52 20.9543 43.0457 12 32 12C20.9543 12 12 20.9543 12 32C12 43.0457 20.9543 52 32 52ZM32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56ZM32 20C30.8954 20 30 20.8954 30 22C30 23.1046 30.8954 24 32 24C33.1046 24 34 23.1046 34 22C34 20.8954 33.1046 20 32 20ZM30 42.6667C30 43.7712 30.8954 44.6667 32 44.6667C33.1046 44.6667 34 43.7712 34 42.6667V29.3333C34 28.2288 33.1046 27.3333 32 27.3333C30.8954 27.3333 30 28.2288 30 29.3333V42.6667Z",
    fill: "#2491E7"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }